import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Row, Col, Card, Button, Select } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { setFilters } from "../intangibleAssetSlice";
import { fetchIntangibleAssetBalance } from "../intangibleAssetThunk";
import { useLocation, useSearchParams } from "react-router-dom";
import CommonDateRangeFilter from "../../../../components/common/filters/CommonDateRangeFilter";
import { useDefaultDateRange } from "../../../../hooks/useDefaultDateRange";
import SearchListAutoComplete from "../../../../components/SearchListAutoComplete";

const { Option } = Select;

const IntangibleAssetBalanceFilters = ({ messageApi }) => {
  const dispatch = useDispatch();
  const { filters } = useSelector((state) => state.intangibleAssetBalance);
  const { pathname } = useLocation();
  const [searchParams] = useSearchParams();

  useDefaultDateRange(setFilters, filters, "today");

  // handleFilterChange only queues the update, so running the report right here
  // would still use the old (default) filters — flag it and run it from the
  // next effect, once the drill-down filters have been applied.
  const [drillReady, setDrillReady] = useState(false);
  useEffect(() => {
    const path = pathname.split("/")[3];
    if (path) {
      handleFilterChange("type", "Date Wise");
      const fromDate = searchParams.get("fromDate");
      if (fromDate) {
        handleFilterChange("fromDate", fromDate);
      }
      handleFilterChange("toDate", path);
      setDrillReady(true);
    }
  }, []);
  useEffect(() => {
    if (drillReady) handleReport();
  }, [drillReady]);

  const handleFilterChange = (field, value) => {
    dispatch(setFilters({ [field]: value }));
  };

  const handleReport = () => {
    if (!filters.type) {
      messageApi.warning("Select Filter Type");
      return;
    }
    dispatch(fetchIntangibleAssetBalance(filters)).then((res) => {
      if (res.meta.requestStatus === "fulfilled") {
        messageApi.success("Report loaded ✅");
      } else {
        messageApi.error("Failed to fetch records ❌");
      }
    });
  };

  return (
    <Card className="product-replace-filters mb-4 shadow-md rounded-xl">
      <Row gutter={[16, 16]} align="middle" wrap>
        <Col xs={24} sm={12} md={4} lg={6}>
          <label>Filter Type</label>
          <Select
            value={filters.type}
            onChange={(val) => handleFilterChange("type", val)}
            style={{ width: "100%" }}
          >
            <Option value="All Intangible Asset Account">
              All Intangible Asset Account
            </Option>
            <Option value="Intangible Asset Account Wise">
              Intangible Asset Account Wise
            </Option>
            <Option value="Date Wise">Date Wise</Option>
          </Select>
        </Col>

        {filters.type === "Date Wise" && (
          <CommonDateRangeFilter
            filters={filters}
            onChange={(fromDate, toDate) => {
              handleFilterChange("fromDate", fromDate);
              handleFilterChange("toDate", toDate);
            }}
          />
        )}

        <Col
          xs={24} sm={12} md={8} lg={4}
          style={{ display: "flex", alignItems: "flex-end", height: 58 }}
        >
          <Button
            type="primary"
            icon={<SearchOutlined />}
            onClick={handleReport}
            block
            style={{ height: 35.18 }}
          >
            Report
          </Button>
        </Col>
      </Row>
    </Card>
  );
};

export default IntangibleAssetBalanceFilters;